/*
 * Sheeply sections — add to cart without leaving the page.
 * Any <form data-gr-add> posting to /cart/add is sent with fetch and
 * the theme's cart drawer / notification is refreshed, like Dawn's
 * own product form. Falls back to the cart page if neither exists.
 */
(() => {
  if (window.grCartReady) return;
  window.grCartReady = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-gr-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    const errorBox = form.querySelector('[role="alert"]');
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (errorBox) {
            errorBox.textContent = response.description || response.message || 'Something went wrong.';
            errorBox.hidden = false;
          }
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(() => {
        form.removeAttribute('data-gr-add');
        form.submit();
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
      });
  });
})();
